export const aiRuleset = {
  captchaSiteKey: '41baf37c-3c9a-46e8-9122-3aa4beb2d96e',
}